function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CloseOutlined, InfoOutlined } from "@mui/icons-material";
import { Checkbox, CircularProgress, FormControl, FormHelperText, IconButton, inputClasses, ListItemText, MenuItem, Input as MuiInput, Select, styled } from "@mui/material";
import { useCamelCase } from "@vestwell-frontend/hooks";
import cn from "clsx";
import { camelCase, isObject } from "lodash";
import { forwardRef, useCallback, useId, useMemo, useState } from "react";
import { useUpdateEffect } from "react-use";
import stringify from "safe-stable-stringify";
import { PLACEHOLDER } from "../consts";
import { FormFieldLabel } from "./form/FormFieldLabel";
import { SelectChevron } from "./SelectChevron";
var parseJson = function(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return json;
    }
};
var StyledCloseBtn = styled(IconButton)(function() {
    return {
        marginRight: '5px'
    };
});
var Input = styled(MuiInput, {
    shouldForwardProp: function(prop) {
        return prop !== 'width';
    }
})(function(param) {
    var className = param.className, fullWidth = param.fullWidth, multiple = param.multiple, theme = param.theme, width = param.width, value = param.value;
    var _obj;
    return _obj = {}, _define_property(_obj, "& .".concat(inputClasses.input), {
        alignItems: 'center',
        color: Array.isArray(value) && !(value === null || value === void 0 ? void 0 : value.length) || !value ? theme.palette.grey400.main : undefined,
        transition: theme.transitions.create([
            'border-color',
            'box-shadow'
        ]),
        whiteSpace: multiple ? 'nowrap' : 'normal !important'
    }), _define_property(_obj, "width", fullWidth ? undefined : width ? theme.spacing(width) : (className === null || className === void 0 ? void 0 : className.includes('w-')) ? undefined : theme.spacing(56)), _obj;
});
Input.displayName = 'Input';
export var Dropdown = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var className = _param.className, details = _param.details, disabled = _param.disabled, error = _param.error, errorMessage = _param.errorMessage, formField = _param.formField, label = _param.label, loading = _param.loading, helpModal = _param.helpModal, hideLabel = _param.hideLabel, hideError = _param.hideError, info = _param.info, noFocusStyle = _param.noFocusStyle, defaultOptions = _param.options, onChange = _param.onChange, onSelect = _param.onSelect, width = _param.width, props = _object_without_properties(_param, [
        "className",
        "details",
        "disabled",
        "error",
        "errorMessage",
        "formField",
        "label",
        "loading",
        "helpModal",
        "hideLabel",
        "hideError",
        "info",
        "noFocusStyle",
        "options",
        "onChange",
        "onSelect",
        "width"
    ]);
    var detailsId = useId();
    var disabledId = useId();
    var helpModalId = useId();
    var errorId = useId();
    var infoId = useId();
    var labelId = useId();
    var describedBy = "".concat(disabled ? "".concat(disabledId, " ") : '').concat(info ? "".concat(infoId, " ") : '').concat(helpModal ? "".concat(helpModalId, " ") : '').concat(details ? "".concat(detailsId, " ") : '').concat(errorMessage ? "".concat(errorId, " ") : '').trimEnd() || undefined;
    var testIdName = useCamelCase(props.name);
    var hasObjectValues = useMemo(function() {
        return defaultOptions.some(function(o) {
            return isObject(o.value);
        });
    }, [
        defaultOptions
    ]);
    var _useState = _sliced_to_array(useState(hasObjectValues ? props.multiple ? (props.value || props.defaultValue || []).map(function(item) {
        return stringify(item);
    }) : stringify(props.value || props.defaultValue || '') : props.value || props.defaultValue || (props.multiple ? [] : '')), 2), value = _useState[0], setValue = _useState[1];
    var onChangeValue = useCallback(function(event) {
        setValue(event.target.value);
    }, []);
    var options = useMemo(function() {
        return defaultOptions.map(function(o) {
            return {
                label: o.label,
                value: hasObjectValues ? stringify(o.value) : o.value
            };
        });
    }, [
        hasObjectValues,
        defaultOptions
    ]);
    var optionsHash = useMemo(function() {
        return options.reduce(function(acc, o) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, o.value, o.label));
        }, {});
    }, [
        options
    ]);
    var renderValue = useCallback(function(selected) {
        if (loading) {
            return /*#__PURE__*/ _jsx(CircularProgress, {
                color: "primary",
                disableShrink: true,
                size: 16,
                variant: "indeterminate"
            });
        }
        if (Array.isArray(selected) && !selected.length || !selected) {
            return props.placeholder ? props.placeholder : (options === null || options === void 0 ? void 0 : options.length) ? 'Select' : PLACEHOLDER;
        }
        if (Array.isArray(selected)) {
            return selected.map(function(item) {
                return optionsHash[item];
            }).join(', ');
        }
        return optionsHash[selected];
    }, [
        loading,
        optionsHash,
        options === null || options === void 0 ? void 0 : options.length
    ]);
    var onClearAll = useCallback(function() {
        setValue([]);
    }, []);
    var slotProps = useMemo(function() {
        return _object_spread({
            listbox: {
                'data-component': 'dropdownListbox',
                'data-testid': testIdName
            },
            popper: {
                'data-component': 'dropdownPopper',
                'data-testid': testIdName
            },
            root: {
                'data-component': 'dropdownRoot',
                'data-testid': testIdName
            }
        }, props.slotProps);
    }, [
        props.slotProps
    ]);
    useUpdateEffect(function() {
        var formattedValue = hasObjectValues ? props.multiple ? value.map(function(item) {
            return parseJson(item);
        }) : parseJson(value) : value;
        if (onSelect) {
            onSelect(formattedValue, props.name);
        }
        if (onChange) {
            onChange(formattedValue);
        }
    }, [
        value
    ]);
    useUpdateEffect(function() {
        var newValue = hasObjectValues && props.value && isObject(props.value) ? stringify(props.value) : props.value;
        var oldValue = hasObjectValues && value && isObject(value) ? stringify(value) : value;
        if (oldValue !== newValue) {
            setValue(function() {
                return newValue;
            });
        }
    }, [
        props.value
    ]);
    return /*#__PURE__*/ _jsxs(FormControl, {
        className: cn('flex', className),
        "data-component": "dropdown",
        "data-testid": testIdName,
        error: error,
        fullWidth: props.fullWidth,
        required: !!props.required,
        children: [
            /*#__PURE__*/ _jsx(FormFieldLabel, {
                "data-component": "dropdownLabel",
                details: details,
                detailsId: detailsId,
                disabled: !!disabled,
                disabledId: disabledId,
                helpModal: helpModal,
                helpModalId: helpModalId,
                hideLabel: hideLabel,
                info: info,
                infoId: infoId,
                label: label,
                labelId: labelId,
                name: props.name,
                required: !!props.required
            }),
            /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, props), {
                MenuProps: {
                    className: 'max-h-82',
                    sx: function(theme) {
                        return {
                            '& .MuiMenuItem-root': {
                                whiteSpace: 'normal'
                            },
                            width: props.fullWidth ? undefined : width ? theme.spacing(width) : (className === null || className === void 0 ? void 0 : className.includes('w-')) ? undefined : theme.spacing(56)
                        };
                    }
                },
                SelectDisplayProps: {
                    'aria-invalid': !!error,
                    'aria-required': !!props.required
                },
                "aria-describedby": describedBy,
                disabled: !!disabled || !!loading,
                displayEmpty: true,
                endAdornment: Array.isArray(value) && value.length > 0 && /*#__PURE__*/ _jsx(StyledCloseBtn, {
                    "aria-label": "Clear all selected values",
                    "data-testid": "clearAll",
                    onClick: onClearAll,
                    size: "small",
                    children: /*#__PURE__*/ _jsx(CloseOutlined, {})
                }),
                input: /*#__PURE__*/ _jsx(Input, {
                    "data-component": "dropdownInputContainer",
                    "data-no-focus-style": noFocusStyle,
                    "data-testid": testIdName,
                    disabled: !!disabled || !!loading,
                    fullWidth: props.fullWidth,
                    multiple: props.multiple,
                    required: !!props.required,
                    width: width
                }),
                inputProps: {
                    IconComponent: function(props) {
                        return Array.isArray(value) && value.length ? undefined : /*#__PURE__*/ _jsx(SelectChevron, {
                            className: props.className
                        });
                    },
                    'data-component': 'dropdownInput',
                    'data-testid': testIdName
                },
                inputRef: ref,
                labelId: labelId,
                notched: undefined,
                onChange: onChangeValue,
                renderValue: renderValue,
                required: !!props.required,
                slotProps: slotProps,
                value: value,
                children: (options === null || options === void 0 ? void 0 : options.length) ? options.map(function(option) {
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        "data-component": "dropdownOption",
                        "data-testid": camelCase(option.label),
                        disableRipple: true,
                        value: option.value,
                        children: props.multiple ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, {
                                    checked: value.includes(option.value)
                                }),
                                /*#__PURE__*/ _jsx(ListItemText, {
                                    primary: option.label,
                                    primaryTypographyProps: {
                                        className: 'mb-0'
                                    }
                                })
                            ]
                        }) : option.label
                    }, option.label);
                }) : /*#__PURE__*/ _jsx("span", {
                    className: "m-2",
                    "data-component": "dropdownNoOptions",
                    "data-testid": camelCase('No options'),
                    children: "No options"
                })
            })),
            formField && /*#__PURE__*/ _jsx(FormHelperText, {
                "aria-atomic": "true",
                className: "mx-0",
                "data-component": "dropdownError",
                "data-testid": testIdName,
                id: errorId,
                role: "alert",
                children: !hideError && errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(InfoOutlined, {
                            className: "mr-1",
                            color: "error",
                            fontSize: "small"
                        }),
                        !!label && /*#__PURE__*/ _jsxs("span", {
                            className: "sr-only",
                            children: [
                                "Error for ",
                                label,
                                ":"
                            ]
                        }),
                        errorMessage
                    ]
                }) : ' '
            })
        ]
    });
});
Dropdown.displayName = 'Dropdown';

//# sourceMappingURL=Dropdown.js.map